import CourseListPage from "../components/pages/course-management/CourseListPage";
import CourseInfoPage from "../components/pages/course-management/CourseInfoPage";
import CourseContentPage from "../components/pages/course-management/CourseContentPage";
import CourseMaterialPage from "../components/pages/course-management/CourseMaterialPage";
import CourseRulePage from "../components/pages/course-management/CourseRulePage";
import EvaluationReport from "../components/pages/course-management/EvaluationReportPage";
import WannasornAdditionalCourseInfoPage from "../components/pages/course-management/WannasornAdditionalCourseInfoPage";
import VideoProcessStatusPage from "../components/pages/course-management/VideoProcessStatusPage";

import CourseGroupListPage from "../components/pages/course-group-management/CourseGroupListPage";
import CourseGroupEditPage from "../components/pages/course-group-management/CourseGroupEditPage";

import ExamManagement from "../components/pages/exam-management/ExamManagement";
import ExamManagementUpload from "../components/pages/exam-management/exam-management-actions/ExamManagementUpload.vue";
import ExamManagementConfirmation from "../components/pages/exam-management/exam-management-actions/ExamManagementConfirmation.vue";
import ExamManagementSuccess from "../components/pages/exam-management/exam-management-actions/ExamManagementSuccess.vue";
import store from "../store/index";

export default [
  /**
   * Index page
   */
  {
    path: "",
    name: "index",
    meta: { access: null },
    component: CourseListPage
  },

  /**
   * Course management
   */
  {
    path: "courses",
    name: "course.management.index",
    meta: { access: { menu: "course", subMenu: "course-mgmt" } },
    component: CourseListPage
  },
  {
    path: "courses/:courseId/info",
    name: "course.management.info",
    component: CourseInfoPage,
    meta: {
      access: { menu: "course", subMenu: "course-mgmt" },
      authRequired: true,
      permsRequired: ["update-course"]
    }
  },
  {
    path: "courses/:courseId/contents",
    name: "course.management.contents",
    component: CourseContentPage,
    meta: {
      access: { menu: "course", subMenu: "course-mgmt" },
      authRequired: true,
      permsRequired: ["update-course"]
    }
  },
  {
    path: "courses/:courseId/materials",
    name: "course.management.materials",
    component: CourseMaterialPage,
    meta: {
      access: { menu: "course", subMenu: "course-mgmt" },
      authRequired: true,
      permsRequired: ["update-course"]
    }
  },
  {
    path: "courses/:courseId/rules",
    name: "course.management.rules",
    component: CourseRulePage,
    meta: {
      access: { menu: "course", subMenu: "course-mgmt" },
      authRequired: true,
      permsRequired: ["update-course"]
    }
  },

  {
    path: "courses/:courseId/evaluation",
    name: "course.management.evaluation",
    component: EvaluationReport,
    meta: {
      access: { menu: "course", subMenu: "course-mgmt" },
      authRequired: true,
      permsRequired: ["update-course"]
    }
  },
  {
    path: "courses/additional-management",
    name: "course.additional.management",
    component: WannasornAdditionalCourseInfoPage,
    meta: {
      access: { menu: "course", subMenu: "course-additional-mgmt" },
      authRequired: true,
      permsRequired: ["update-course"]
    }
  },
  {
    path: "courses/video-process-status",
    name: "course.video-process-status",
    component: VideoProcessStatusPage,
    meta: {
      access: { menu: "course", subMenu: "course-video-process-status" },
      authRequired: true,
      permsRequired: ["update-course"]
    }
  },

  /**
   * Course group management
   */
  {
    path: "courses-group",
    name: "course-group.management.index",
    meta: { access: { menu: "course", subMenu: "course-group-mgmt" } },
    component: CourseGroupListPage
  },
  {
    path: "courses-group/:id",
    name: "course-group.management.edit",
    meta: { access: { menu: "course", subMenu: "course-group-mgmt" } },
    component: CourseGroupEditPage
  },

  /**
   * Exam management
   */
  {
    path: "exam-management",
    name: "company.exam-management",
    component: ExamManagement,
    props: true,
    meta: {
      access: { menu: "exam", subMenu: "exam-upload" },
      authRequired: true,
      module: "exam-management",
      permsRequired: [
        "read-exam-analytic",
        "create-exam",
        "update-exam",
        "delete-exam"
      ]
    },
    redirect: {
      name: "company.exam-management.upload"
    },
    children: [
      {
        path: "upload",
        name: "company.exam-management.upload",
        meta: {
          access: { menu: "exam", subMenu: "exam-upload" },
          module: "exam-management"
        },
        component: ExamManagementUpload,
        props: true
      },
      {
        path: "confirmation",
        name: "company.exam-management.confirmation",
        component: ExamManagementConfirmation,
        meta: {
          access: { menu: "exam", subMenu: "exam-upload" },
          module: "exam-management"
        },
        props: true,
        beforeEnter(to, _, next) {
          if (!store.getters["ExamManagement/companyUploadedCsvData"]) {
            next({
              name: "company.exam-management",
              params: to.params
            });
            return;
          }
          next();
        }
      },
      {
        path: "success",
        name: "company.exam-management.success",
        component: ExamManagementSuccess,
        meta: {
          access: { menu: "exam", subMenu: "exam-upload" },
          module: "exam-management"
        },
        props: true,
        beforeEnter(to, _, next) {
          if (!store.getters["ExamManagement/companyUploadedCsvData"]) {
            next({
              name: "company.exam-management",
              params: to.params
            });
            return;
          }
          next();
        }
      }
    ]
  }
];
